import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useClinicTheme } from "../../../theme";
import { COLORS } from "../../../styles/uiConstants";

/**
 * İskeletin ÜSTÜNDE duran yükleme katmanı. Liste yüklenirken iskele yapı
 * arkada silik görünür, kullanıcı ne beklediğini bilir.
 */
export default function ListLoadingOverlay({ message = "Yükleniyor..." }) {
  const { palette } = useClinicTheme();

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        bgcolor: "rgba(255,255,255,0.72)",
      }}
    >
      <CircularProgress size={36} thickness={4} sx={{ color: palette.primary }} />
      {message ? (
        <Typography variant="body2" sx={{ fontWeight: 600, color: COLORS.slate600 }}>
          {message}
        </Typography>
      ) : null}
    </Box>
  );
}
